// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".core-image-blocks li .wp-block-image img{height:5rem;width:5rem;max-width:none;border-radius:0.25rem;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}.core-image-blocks li figcaption{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
